// Associate failures with local request context without changing errors, adding
// headers or attaching private request data to exceptions.
const requests = new WeakMap<object, { id?: string; status?: number }>();

export function requestStatusFor(source: unknown): number | undefined {
  if (source === null || typeof source !== 'object') return undefined;
  const detail = source as { status?: unknown; result?: { status?: unknown } };
  const status =
    detail.status ?? detail.result?.status ?? requests.get(source)?.status;
  return typeof status === 'number' &&
    Number.isInteger(status) &&
    status >= 0 &&
    status <= 599
    ? status
    : undefined;
}

export function rememberRequest(error: unknown, requestId: string): void {
  if (error !== null && typeof error === 'object')
    requests.set(error, { id: requestId, status: requestStatusFor(error) });
}

export function requestIdFor(error: unknown): string | undefined {
  return error !== null && typeof error === 'object'
    ? requests.get(error)?.id
    : undefined;
}

export function inheritRequestCorrelation<T>(error: T, source: unknown): T {
  if (error !== null && typeof error === 'object') {
    const id = requestIdFor(source);
    const status = requestStatusFor(source);
    if (id || status !== undefined) requests.set(error, { id, status });
  }
  return error;
}
